import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks/hooks";
import { selectJobsListItems } from "../../../../../../redux/jobs/selector";
import { jobs } from "../../../../../../redux/jobs/action";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import storePersist from "../../../../../../redux/storePersist";
import _ from 'lodash';
import useWindowDimensions from "../../../../../../hooks/useWindowsDimensions";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { toast } from "react-toastify";

const TransportAgentJobs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { height, width } = useWindowDimensions();
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJobsListItems)

  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'TransportAgent']);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.OrderId', headerName: 'OrderId' },
      { field: 'Message.ShipmentInfo.DeliveryDateUtc', headerName: 'Schedule Date & Time', isDateValueFormat: true },
      { field: 'Message.PhoneNumber', headerName: 'Phone', },
      { field: 'Message.IsRTOJOB', headerName: 'RTO JOB', cellRenderer: 'yesNoRenderer' },
      { field: 'Message.IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      {
        field: 'Message.LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      {
        field: 'Message.ShipmentInfo.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      { field: `Message.DelayedPickupTime`, headerName: 'Delayed Pickup Time(Mins)' },
      { field: 'Message.PickupCode', headerName: 'Pickup Code' },
      { field: 'Message.PickupInfo.location', headerName: 'From Address', isAddressFormat: true },
      { field: `Message.DelayedDeliveryTime`, headerName: 'Delayed Delivery Time(Mins)' },
      { field: 'Message.DeliveryCode', headerName: 'Delivery Code' },
      { field: 'Message.DeliveryInfo.location', headerName: 'To Address', isAddressFormat: true },
      { field: 'Message.JobNotes', headerName: 'Notes', },
      { field: 'Message.CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = async () => {
    await dispatch(jobs.resetAction({ actionType: 'list' }))
    await dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TransportAgentId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }))
  }

  const launchPdfInBrowser = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (!data?.Message?.ShipmentTrackingNumber) {
      toast.error("Eway Number is null or empty. Cannot open PDF.");
      return;
    }

    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/e-way/${data?.Message?.ShipmentTrackingNumber}`,
        '_blank',
        windowProps
      );
    }
  }

  const handleGeneratePrintEWayBill = async (data: any) => {

    launchPdfInBrowser(data);
  }

  useEffect(() => {
    createColumnDefs()
    fetchJobs()

  }, [pageData, pageSize])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :

        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={itemsData?.result?.items}
          onEdit={handleEdit}
          setPageSize={setPageSize}
          setPageData={setPageData}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onGeneratePdfInvoice={handleGeneratePrintEWayBill}
          paginationData={itemsData?.result?.pagination}
          headingName="Jobs" />

      }
    </>

  );
};

export default TransportAgentJobs;